var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHome(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_230_2450)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.97984 17.0001H4.18817L16.7507 4.43759L29.3132 17.0001H26.5215",
    stroke: "#6D6D6D",
    strokeWidth: 2.79167,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.9798 17.0001V26.7709C6.9798 27.5113 7.27392 28.2214 7.79746 28.7449C8.321 29.2685 9.03107 29.5626 9.77146 29.5626H23.7298C24.4702 29.5626 25.1803 29.2685 25.7038 28.7449C26.2273 28.2214 26.5215 27.5113 26.5215 26.7709V17.0001",
    stroke: "#6D6D6D",
    strokeWidth: 2.79167,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5632 29.5626V21.1876C12.5632 20.4472 12.8573 19.7371 13.3808 19.2136C13.9044 18.69 14.6144 18.3959 15.3548 18.3959H18.1465C18.8869 18.3959 19.597 18.69 20.1205 19.2136C20.644 19.7371 20.9382 20.4472 20.9382 21.1876V29.5626",
    stroke: "#6D6D6D",
    strokeWidth: 2.79167,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_230_2450"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 33.5,
    height: 33.5,
    fill: "white",
    transform: "translate(0 0.25)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.dd1a72a3189f13a551d90c61aac59469.svg";
export { ForwardRef as ReactComponent };